import React from "react";
import { Outlet } from "react-router-dom";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import Modal from "../components/Modal";
import EbookForm from "../components/EbookForm";
import GetDemoForm from "../components/GetDemoForm";
import CalendlyModal from "../components/CalendlyModal";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const MasterLayout = ({
  openEbookModal,
  setOpenEbookModal,
  openGetDemoModal,
  setOpenGetDemoModal,
  openCalendlyModal,
  setOpenCalendlyModal,
  closeModal, // from useModals
}) => {
  const { i18n, t } = useTranslation();
  const orgHy = {
    "@type": "Organization",
    name: "ITResources",
    url: "https://ariari.am",
    logo: "https://ariari.am/logo.png",
    sameAs: [
      "https://www.facebook.com/ITResources.am",
      "https://www.linkedin.com/company/itresources-armenia",
    ],
    description:
      "ITResources-ը Ari Ari համակարգի ստեղծողն է՝ առաջարկելով խելացի կայանման կառավարման լուծումներ, որոնք միավորում են ավտոմատ մուտք/ելքը, վճարումները և մոնիտորինգը։",
    email: "info@ariari.am",
    address: {
      "@type": "PostalAddress",
      addressCountry: "AM",
      addressLocality: "Երևան",
      addressRegion: "Երևան",
      postalCode: "0001",
      streetAddress: "Խանջյան 67",
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      telephone: "+374 41 99 60 08",
      areaServed: "AM",
    },
  };

  const orgEn = {
    ...orgHy,
    description:
      "ITResources is the creator of the Ari Ari system, offering smart parking management solutions that integrate automated entry/exit, payments, and real-time monitoring.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "AM",
      addressLocality: "Yerevan",
      addressRegion: "Yerevan",
      postalCode: "0001",
      streetAddress: "67 Khanjyan St",
    },
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      telephone: "+374 41 99 60 08",
      areaServed: "AM",
    },
  };

  const productHy = {
    "@type": "Product",
    name: "Ari Ari",
    url: "https://ariari.am",
    image: "https://ariari.am/assets/og-image.jpg",
    description:
      "Ari Ari-ն խելացի կայանման կառավարման համակարգ է, որը ավտոմատացնում է մուտք-ելքը, վճարումները և տեսահսկումը։ Հարմարեցվում է բիզնեսների, համայնքների և քաղաքային տարածքների կարիքներին։",
    brand: {
      "@type": "Brand",
      name: "Ari Ari",
    },
    manufacturer: {
      "@type": "Organization",
      name: "ITResources",
    },
    offers: {
      "@type": "Offer",
      priceCurrency: "AMD",
      availability: "https://schema.org/InStock",
    },
  };

  const productEn = {
    ...productHy,
    name: "Ari Ari",
    description:
      "Ari Ari is a smart parking management platform that automates entry/exit, payments, and surveillance. It is customizable for businesses, municipalities, and urban parking lots.",
  };

  const globalSchema = {
    "@context": "https://schema.org",
    "@graph": [
      i18n.language === "hy" ? orgHy : orgEn,
      i18n.language === "hy" ? productHy : productEn,
      {
        "@type": "WebSite",
        "@id": "https://ariari.am/#website",
        url: "https://ariari.am/",
        name: "Ari Ari",
        inLanguage: i18n.language,
        publisher: { "@id": "https://ariari.am/#organization" },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
        <meta name="keywords" content={t("meta.keywords")} />
        <script type="application/ld+json">
          {JSON.stringify(globalSchema)}
        </script>
      </Helmet>

      {/* Header */}
      <HeaderOne setOpenGetDemoModal={setOpenGetDemoModal} />

      {/* Page Content */}
      <Outlet />

      {/* Footer */}
      <FooterOne />

      {/* Modals */}
      <Modal
        isOpen={openEbookModal}
        onClose={() => closeModal("ebook")}
        title={t("becomeSellerTwo.ebookModal.title")}
      >
        <EbookForm />
      </Modal>

      <Modal
        isOpen={openGetDemoModal}
        onClose={() => closeModal("getDemo")}
        title={t("getDemoForm.title")}
      >
        <GetDemoForm />
      </Modal>

      <Modal
        isOpen={openCalendlyModal}
        onClose={() => closeModal("calendly")}
        large="large"
      >
        <CalendlyModal />
      </Modal>
    </>
  );
};

export default MasterLayout;
